import { createRoot } from "react-dom/client";
import { CaseCreationForm } from "../../athena/CaseCreationForm";

export function initAthenaCaseCreationForm() {
  const container = document.getElementById("athena-case-form");

  if (container) {
    const root = createRoot(container);

    const { logoPath, biLinkUrl, paLinkUrl } = container.dataset;

    root.render(<CaseCreationForm logoPath={logoPath} biSubmitUrl={biLinkUrl} paSubmitUrl={paLinkUrl} />);
  }
}
